import React from "react";
import ListCalendar from "./ListCalendar";
import OrderList from "./OrderList";
import { Macros } from "../models/Macros";
import { useAppContext } from "../contexts/AppContext";
import { TListCalendarWrapperProps } from "../types/components/ListCalendarWrapper";

type TOrderListCalendarProps = {
    id: number;
    onInfoOpen?: (orderIds: number[], openIfClosed?: boolean) => void;
} & TListCalendarWrapperProps;

const getRefreshEvents = () => [
    Macros.Event.SELECT_RESERVATION,
    Macros.Event.RESERVATION_MADE_OR_MODIFIED,
    Macros.Event.RESERVATION_RESTORED,
];

const OrderListCalendar = (props: TOrderListCalendarProps) => {
    const appContext = useAppContext();

    const onSelection = (selection, descriptionField, commentField) => {
        appContext.fireEvent(
            `orderList${props.id}`,
            Macros.Event.SELECT_ORDER,
            selection,
            descriptionField,
            commentField
        );
    };

    return (
        <ListCalendar
            {...props}
            type={"orderList"}
            refreshEvents={getRefreshEvents()}
            onSelection={onSelection}
        >
            <OrderList />
        </ListCalendar>
    );
};

export default OrderListCalendar;
